// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"28105c58","977":"e81cb04b"}[chunkId] + ".chunk.js";
};